// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".labelWrapper--1_jpdPIU {\n  display: flex;\n  cursor: pointer;\n  gap: 8px;\n  align-items: center;\n}\n  .labelWrapper--1_jpdPIU .labelIcon--3OdPS5k8 {\n    color: var(--color-secondary-text);\n  }\n  .labelWrapper--1_jpdPIU .labelIcon--3OdPS5k8.selected--3Zd8S7HK {\n      color: var(--antd-link-hover-color);\n    }\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"labelWrapper": "labelWrapper--1_jpdPIU",
	"labelIcon": "labelIcon--3OdPS5k8",
	"selected": "selected--3Zd8S7HK"
};
export default ___CSS_LOADER_EXPORT___;
